import axios from "axios";
import qs from "querystring";
import state from "@/store";
import { Author } from "../api/api";
axios.defaults.timeout = 60000;
axios.defaults.baseURL = window.apiHost;
 axios.defaults.crossDomain = false;
axios.defaults.withCredentials = false;

//请求劫持
axios.interceptors.request.use(
  config => {
    try {
      config.headers['cip'] = returnCitySN['cip']
    } catch (error) {
      
    }
    if (config.method === "POST") {
      config.data = qs.stringify(config.data, { arrayFormat: "indices" });
    }
    if (config.method === 'get' || config.method === 'GET') {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      }
      if(config.url == '/api/Web/IssueDownLoad'){
        config.responseType = 'blob'
      }
      config.onDownloadProgress = progressEvent  => {
        if(progressEvent.total>307200){
          state.state.progressNum = (progressEvent.loaded) / (progressEvent.total)
        }
        }
    }
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json;utf-8";
    }
	if (localStorage.getItem("userInfo")){
		var userinfo=localStorage.getItem("userInfo");
		config.headers["Authorization"]="Bearer "+JSON.parse(userinfo).Token
	}
  
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
export default axios;
